

// import { useState, useRef } from "react";
// import { Box, TextField, IconButton, Typography } from "@mui/material";
// import SendIcon from "@mui/icons-material/Send";
// import MicIcon from "@mui/icons-material/Mic";
// import MicOffIcon from "@mui/icons-material/MicOff";
// import { keyframes } from "@mui/system";
// import StopIcon from "@mui/icons-material/Stop";

// /* 🔴 Pulse animation for mic */
// const pulse = keyframes`
//   0% { box-shadow: 0 0 0 0 rgba(211,47,47, 0.7); }
//   70% { box-shadow: 0 0 0 10px rgba(211,47,47, 0); }
//   100% { box-shadow: 0 0 0 0 rgba(211,47,47, 0); }
// `;

// /* 📶 Wave animation */
// const wave = keyframes`
//   0% { height: 6px; }
//   50% { height: 16px; }
//   100% { height: 6px; }
// `;

// export default function MessageInput({ onSend }) {
//   const [text, setText] = useState(""); // State to hold the input field text
//   const [recording, setRecording] = useState(false); // Recording state
//   const [audioUrl, setAudioUrl] = useState(null); // Audio preview state

//   const mediaRecorderRef = useRef(null);
//   const audioChunksRef = useRef([]);

//   // Handle send button click
//   const handleSend = () => {
//     if (!text.trim()) return; // Prevent sending if no text
//     onSend(text); // Send the transcribed or typed text
//     setText(""); // Clear the input field after sending
//   };

//   // Start recording the audio
//   const startRecording = async () => {
//     if (!navigator.mediaDevices?.getUserMedia) {
//       alert("Audio recording not supported");
//       return;
//     }

//     const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//     const mediaRecorder = new MediaRecorder(stream);

//     mediaRecorderRef.current = mediaRecorder;
//     audioChunksRef.current = [];

//     mediaRecorder.ondataavailable = (e) => {
//       if (e.data.size > 0) audioChunksRef.current.push(e.data);
//     };

//     mediaRecorder.onstop = async () => {
//       const audioBlob = new Blob(audioChunksRef.current, { type: "audio/webm" });

//       // 🔹 Preview (optional)
//       const localUrl = URL.createObjectURL(audioBlob);
//       setAudioUrl(localUrl);

//       // 🔹 Send audio to backend for transcription
//       const formData = new FormData();
//       formData.append("audio", audioBlob, "recording.webm");

//       try {
//         const res = await fetch("http://localhost:5099/api/transcribe", {
//           method: "POST",
//           body: formData,
//           // ❌ Do not manually set Content-Type (multipart/form-data is automatically handled)
//         });

//         const data = await res.json();

//         if (data.success && data.transcription) {
//           // Clean up the transcription text to extract only the raw text
//           const cleanedText = data.transcription
//             .replace(/{ transcription = /, "") // Remove starting part
//             .replace(/ }$/, "") // Remove ending part
//             .trim(); // Remove leading/trailing spaces

//           setText(cleanedText); // Set cleaned transcription to the text field
//         } else {
//           console.error("Transcription failed:", data);
//         }
//       } catch (err) {
//         console.error("Error sending audio:", err);
//       }

//       // Stop mic tracks after recording
//       mediaRecorder.stream.getTracks().forEach((t) => t.stop());
//     };

//     mediaRecorder.start();
//     setRecording(true);
//   };

//   // Stop the recording
//   const stopRecording = () => {
//     mediaRecorderRef.current?.stop();
//     setRecording(false);
//   };

//   // Toggle between recording and stopping recording
//   const toggleRecording = () => {
//     recording ? stopRecording() : startRecording();
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         gap: 1,
//         maxWidth: 900,
//         mx: "auto",
//         p: 1.5,
//         bgcolor: "#fff",
//         borderRadius: "25px",
//         boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
//       }}
//     >
//       {/* 🔹 Input Row */}
//       <Box sx={{ display: "flex", alignItems: "center" }}>
//         <TextField
//           fullWidth
//           placeholder="Type a message..."
//           variant="outlined"
//           value={text}
//           onChange={(e) => setText(e.target.value)} // Update state when user types
//           onKeyDown={(e) => e.key === "Enter" && handleSend()} // Send on Enter key press
//           sx={{
//             bgcolor: "#f0f0f0",
//             borderRadius: "20px",
//           }}
//         />

//         {/* 🎙 Mic Button */}
//         <IconButton
//           onClick={toggleRecording}
//           sx={{
//             ml: 1,
//             bgcolor: recording ? "#2563eb" : "#2563eb",
//             color: "#fff",
//             borderRadius: "50%",
//             p: 1.5,
//             animation: recording ? `${pulse} 1.5s infinite` : "none",
//             "&:hover": {
//               bgcolor: recording ? "#b71c1c" : "#303f9f",
//             },
//           }}
//         >
//           {recording ? <StopIcon  /> : <MicIcon />}
//         </IconButton>

//         {/* 📤 Send Button */}
//         <IconButton
//           onClick={handleSend}
//           disabled={recording} // Disable Send button while recording
//           sx={{
//             ml: 1,
//             bgcolor: "#2563eb",
//             color: "#fff",
//             borderRadius: "50%",
//             p: 1.5,
//             "&:hover": { bgcolor: "#303f9f" },
//           }}
//         >
//           <SendIcon />
//         </IconButton>
//       </Box>

//       {/* 📶 Recording Indicator */}
//       {recording && (
//         <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, px: 2 }}>
//           {[1, 2, 3, 4].map((i) => (
//             <Box
//               key={i}
//               sx={{
//                 width: 4,
//                 bgcolor: "#d32f2f",
//                 borderRadius: 2,
//                 animation: `${wave} 1s ease-in-out infinite`,
//                 animationDelay: `${i * 0.15}s`,
//               }}
//             />
//           ))}
//           <Typography sx={{ ml: 1, color: "#d32f2f", fontSize: "0.85rem" }}>
//             Recording…
//           </Typography>
//         </Box>
//       )}

//       {/* 🎧 Audio Preview */}
//       {/* {audioUrl && <audio controls src={audioUrl} style={{ width: "100%" }} />} */}
//     </Box>
//   );
// }



import { useState, useRef } from "react";
import { Box, TextField, IconButton, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import MicIcon from "@mui/icons-material/Mic";
import StopIcon from "@mui/icons-material/Stop";
import { keyframes } from "@mui/system";

/* 🔴 Pulse animation for mic */
const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(211,47,47, 0.7); }
  70% { box-shadow: 0 0 0 10px rgba(211,47,47, 0); }
  100% { box-shadow: 0 0 0 0 rgba(211,47,47, 0); }
`;

/* 📶 Wave animation */
const wave = keyframes`
  0% { height: 6px; }
  50% { height: 16px; }
  100% { height: 6px; }
`;

export default function MessageInput({ onSend, disabled, onStop }) {
  const [text, setText] = useState("");
  const [recording, setRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const handleSend = () => {
    if (!text.trim() || disabled) return;
    onSend(text);
    setText("");
  };

  const startRecording = async () => {
    if (disabled) return; // disable recording while AI is processing
    if (!navigator.mediaDevices?.getUserMedia) return alert("Audio not supported");

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mediaRecorder = new MediaRecorder(stream);
    mediaRecorderRef.current = mediaRecorder;
    audioChunksRef.current = [];

    mediaRecorder.ondataavailable = (e) => {
      if (e.data.size > 0) audioChunksRef.current.push(e.data);
    };

    mediaRecorder.onstop = async () => {
      const audioBlob = new Blob(audioChunksRef.current, { type: "audio/webm" });

      const formData = new FormData();
      formData.append("audio", audioBlob, "recording.webm");

      try {
        const res = await fetch("http://localhost:5099/api/transcribe", {
          method: "POST",
          body: formData,
        });

        const data = await res.json();

        if (data.success && data.transcription) {
          // Clean transcription: remove "{ transcription = ... }"
          const cleanedText = data.transcription
            .replace(/^\{?\s*transcription\s*=\s*/, "")
            .replace(/\s*\}?$/, "")
            .trim();

          setText(cleanedText);
        } else {
          console.error("Transcription failed:", data);
        }
      } catch (err) {
        console.error("Error sending audio:", err);
      }

      mediaRecorder.stream.getTracks().forEach((t) => t.stop());
      setRecording(false);
    };

    mediaRecorder.start();
    setRecording(true);
  };

  const stopRecording = () => {
    if (!recording) return;
    mediaRecorderRef.current?.stop();
    setRecording(false);
  };

  const toggleRecording = () => {
    recording ? stopRecording() : startRecording();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        maxWidth: 900,
        mx: "auto",
        p: 1.5,
        bgcolor: "#fff",
        borderRadius: "25px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
      <TextField
  autoFocus
  fullWidth
  placeholder="Type a message..."
  variant="outlined"
  value={text}
  onChange={(e) => setText(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === "Enter" && !disabled && !recording) {
      e.preventDefault();
      handleSend();
    }
  }}
  multiline
  minRows={1}
  maxRows={6}
  sx={{
    bgcolor: "#f0f0f0",
    borderRadius: "20px",
    overflow: "auto",
    padding: "8px 16px",
  }}
/>

        {/* 🎙 Mic button */}
        <IconButton
          onClick={toggleRecording}
          disabled={disabled} // ✅ disabled while AI response is processing
          sx={{
            ml: 1,
            bgcolor: recording ? "#2563eb" : "#2563eb",
            color: "#fff",
            borderRadius: "50%",
            p: 1.5,
            animation: recording ? `${pulse} 1.5s infinite` : "none",
            "&:hover": { bgcolor: recording ? "#b71c1c" : "#303f9f" },
          }}
        >
          {recording ? <StopIcon /> : <MicIcon />}
        </IconButton>

        {/* 📤 Send button */}
        <IconButton
          onClick={disabled ? onStop : handleSend}
          disabled={recording && !disabled}
          sx={{
            ml: 1,
            bgcolor: disabled ? "#ff6b6b" : "#2563eb",
            color: "#fff",
            borderRadius: "50%",
            p: 1.5,
            "&:hover": { bgcolor: disabled ? "#d32f2f" : "#303f9f" },
          }}
        >
          {disabled ? <StopIcon /> : <SendIcon />}
        </IconButton>
      </Box>
    </Box>
  );
}



